import React, { useState, useEffect } from 'react';
import RetailerLogin from './RetailerLogin';
import RetailerPage from './RetailerPage';
import axios from 'axios';

const RetailerHome = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('retailerToken'));
  const [token, setToken] = useState(localStorage.getItem('retailerToken'));
  const [profile, setProfile] = useState(null);

 
  useEffect(() => {
    const fetchProfile = async () => {
      if (isLoggedIn && token) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/auth/Retailerprofile`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setProfile(response.data.profile);
        } catch (error) {
          console.error('Profile retrieval failed:', error);
          handleLogout();
        }
      }
    };
    
    if (isLoggedIn && token) {
      fetchProfile();
    }
  }, [isLoggedIn, token]);

  const handleLogin = (newToken) => {
    if (newToken) {
      // Clear any existing owner session
      localStorage.removeItem('ownerToken');
      
      // Set retailer session
      setToken(newToken);
      setIsLoggedIn(true);
      localStorage.setItem('retailerToken', newToken);
      console.log('Retailer logged in, Owner session cleared');
    } else {
      console.error('Invalid token');
    }
  };

  const handleLogout = () => {
    setToken(null);
    setIsLoggedIn(false);
    setProfile(null);
    localStorage.removeItem('retailerToken');
    console.log('Logged out');
  };

  return (
    <div className="Container_Home">
      {isLoggedIn ? (
        profile ? (
          <RetailerPage className="owner-page" profile={profile} onLogout={handleLogout} />
        ) : (
          <p><button className="logout" onClick={handleLogout}>Logout</button></p>
        )
      ) : (
        <RetailerLogin onLogin={handleLogin} />
      )}
    </div>
  );
};

export default RetailerHome;
